module.exports = __webpack_public_path__ + "static/media/545GriffinStNW_2018-06-05_21.fb9b95ee.jpg";